var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"preview-container"},[_c('div',{staticClass:"preview"},[_c('img',{staticClass:"preview-img",attrs:{"src":_vm.url}}),_vm._v(" "),_c('i',{staticClass:"box center icon-close el-icon-error",attrs:{"title":"关闭预览"},on:{"click":_vm.onClosePreview}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-10b4c8f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/webpc/Preview/template.vue
// module id = null
// module chunks = 